import Button, { BUTTON_VARIANT } from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useState, useEffect } from "react";
// import EditIncidentModal from "./EditIncidentModal";
import EditVisitorModal from "./EditVisitorModal";
import { ActionsHeader, VisitorListContainer } from "./styles";
import { useSelector } from "react-redux";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";

const headers = [
  { key: "visitorLogId", text: "ID" },
  { key: "fullName", text: "Full Name" },
  { key: "reasonForVisit", text: "Reason for Visit" },
  { key: "scheduledDateTime", text: "Scheduled" },
  { key: "arrivalDateTime", text: "Arrival" },
  { key: "departureDateTime", text: "Departure" },
];

const VisitorList = ({ switchToAddVisitor, isBookings = false }) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [visitorsLog, setVisitorsLog] = useState([]);
  const [modalShown, setModalShown] = useState(false);
  const [editVisitors, setEditVisitors] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  
  useEffect(() => {
    const loadVisitors = async () => {
      if (!bookings?.visitorLogBooking?.length) {
        setVisitorsLog([]);
        return;
      }

      try {
        // 1️⃣ Extract visitorLogIds from bookings API
        const visitorLogIds = bookings.visitorLogBooking
          .map(v => v.visitorLogId)
          .filter(Boolean);

        if (!visitorLogIds.length) {
          setVisitorsLog([]);
          return;
        }

        // 2️⃣ POST API call
        const resp = await api.post(
          API_ENDPOINTS.visitorLog.getVisitorDetailsByID,
          visitorLogIds
        );

        const visitorDetails = resp?.data || [];

        // 3️⃣ Build table rows
        buildVisitorTable(visitorDetails);
      } catch (err) {
        console.error("Failed to load visitor logs", err);
        setVisitorsLog([]);
      }
    };

    loadVisitors();
  }, [bookings]);

  const buildVisitorTable = (visitorDetails = []) => {
    const allVisitors = visitorDetails.map((log) => {
      const bookingInfo = log.visitorLogBooking?.[0] || {};
      const inmate = log.visitorLogInmate?.[0] || {};
      const bio = log.bio?.[0] || {};

      return {
        ...log,

        visitorLogBookingId: bookingInfo.visitorLogBookingId,
        bookingId: bookingInfo.bookingId,

        fullName: `${bio.fName || ""} ${bio.lName || ""}`,

        inmateFirstName: inmate.inmateFirstName || "",
        inmateLastName: inmate.inmateLastName || "",

        scheduledDateTime:
          log.scheduledDate && log.scheduledTime
            ? `${log.scheduledDate} ${log.scheduledTime}`
            : "",

        arrivalDateTime:
          log.arrivalDate && log.arrivalTime
            ? `${log.arrivalDate} ${log.arrivalTime}`
            : "",

        departureDateTime:
          log.departureDate && log.departureTime
            ? `${log.departureDate} ${log.departureTime}`
            : "",
      };
    });

    setVisitorsLog(allVisitors);
  };


  const onModalShow = () => setModalShown(true);
  const onModalHide = () => {
    setModalShown(false);
    setSelectedVisitor(null);
  };
  const onRowSelect = (rowData) => {
    setSelectedVisitor(rowData);
    setEditVisitors(true);
  };

  return (
    <>
      {" "}
      <VisitorListContainer>
        <ActionsHeader className="action-header-row">
          <div className="left">
            {!isBookings && (
              <Button
                variant={BUTTON_VARIANT.DARK}
                onClick={switchToAddVisitor}
                disabled={!bookingsFieldsEnabled}
              >
                Add Visitor
              </Button>
            )}
          </div>

          <div className="right">
            {visitorsLog.length > 0 && (
              <Button
                variant={BUTTON_VARIANT.DARK}
                onClick={onModalShow}
                disabled={!editVisitors || !selectedVisitor}
              >
                {!isBookings ? "Details" : "View Details"}
              </Button>
            )}
            {!isBookings && (
              <Button variant={BUTTON_VARIANT.DARK} disabled={!editVisitors}>
                Delete
              </Button>
            )}
          </div>
        </ActionsHeader>
        <Table
          headers={headers}
          data={visitorsLog}
          onRowClick={onRowSelect}
          onRowDoubleClick={(data) => {
            onRowSelect(data);
            onModalShow();
          }}
          selected={!selectedVisitor}
        />
      </VisitorListContainer>
      <EditVisitorModal
        isBookings={isBookings}
        show={modalShown}
        onHide={onModalHide}
        initialData={selectedVisitor}
      />
    </>
  );
};

export default VisitorList;
